import { render } from "./BtnGreenSmall.vue?vue&type=template&id=d0d99e66&scoped=true"
import script from "./BtnGreenSmall.vue?vue&type=script&lang=js"
export * from "./BtnGreenSmall.vue?vue&type=script&lang=js"

import "./BtnGreenSmall.vue?vue&type=style&index=0&id=d0d99e66&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d99e66"]])

export default __exports__